
















































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayBookingInfoJson from "../../shared/BirthdayBookingInfoJson";
import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import UserJson from "../../shared/UserJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysBookings",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      birthdayInfo: null as BirthdayBookingInfoJson | null,
      bookedBirthdayBookings: null as BirthdayBookingJson[] | null,
      bookedBirthdayBookingsMoreAvailable: null as boolean | null,
      filteredBirthdayBookings: null as BirthdayBookingJson[] | null,
      useFilters: false as boolean,
      filterDate: "" as string,
      cachedFilterDate: "" as string,
      searchStringBooked: null as string | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
      loadingSearchBooked: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    printTodayBirthdays() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view-today");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();

        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    printStaffBirthdays() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view-staff");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();

        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadAllBookedBirthdays();
      this.loadBirthdayInfo();
      this.loadAllUsers();
    },

    async loadBirthdayInfo() {
      try {
        let rc = RestClient;
        this.birthdayInfo = await rc.getBirthdayBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAllBookedBirthdays(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchStringBooked !== null) {
        if (loadMore == null) {
          this.bookedBirthdayBookings = null;
        }
        if (this.searchStringBooked == "") {
          this.searchStringBooked = null;
        }
      }

      var states: BirthdayBookingStatus[] = [
        BirthdayBookingStatus.booked,
        BirthdayBookingStatus.readyForPayment,
        BirthdayBookingStatus.paymentExported,
      ];

      var afterDateTime = new Date();
      afterDateTime.setHours(0, 0, 0, 0);
      var beforeDateTime = null;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        //show birthdays with specific date
        if (this.filterDate != "") {
          afterDateTime = new Date(this.filterDate);
          beforeDateTime = new Date(afterDateTime);
          beforeDateTime.setDate(afterDateTime.getDate() + 1);
        }
      }

      //load more
      if (loadMore && this.bookedBirthdayBookings != null) {
        this.bookedBirthdayBookingsMoreAvailable = null;

        skipAmount = this.bookedBirthdayBookings.length;
      } else {
        this.bookedBirthdayBookings = null;
      }

      //final load birthdays
      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(
            states,
            null,
            afterDateTime,
            beforeDateTime,
            this.searchStringBooked,
            null,
            skipAmount
          );

          if (loadMore && this.bookedBirthdayBookings != null) {
            this.bookedBirthdayBookings = this.bookedBirthdayBookings.concat(birthdays.birthdayBookings);
          } else {
            this.bookedBirthdayBookings = birthdays.birthdayBookings;
          }

          this.bookedBirthdayBookingsMoreAvailable = birthdays.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //todo: viell. in Zukunft nur die einzelnen User laden
    async loadAllUsers() {
      try {
        this.allUsers = await this.restClient.getUsers();
      } catch (e) {
        alert(e.message);
      }
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "--";
      }
    },

    getStaffFirstName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName;
        }
      } else {
        return "--";
      }
    },

    getChildAge(birthDate: string) {
      let today = new Date();
      let date = new Date(birthDate);

      let age = today.getFullYear() - date.getFullYear();
      let month = today.getMonth() - date.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < date.getDate())) {
        age--;
      }

      return age;
    },

    /*
    permissionAble: function(item: BirthdayBookingJson) {
      if (
        this.loginPermission > item.permissionRank ||
        this.loginPermission == this.UserPermissionRank.admin ||
        this.loginId == item.ID
      ) {
        return true
      } else {
        return false
      }
    },
*/

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadAllBookedBirthdays();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadAllBookedBirthdays();
    },

    setFilterDate() {
      var filterDate = "";

      if (this.cachedFilterDate) {
        if (this.supportsDatePicker) {
          filterDate = DateFormatter.formatUSDate(new Date(this.cachedFilterDate));
        } else {
          if (this.cachedFilterDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedFilterDate);

            if (d != null) {
              filterDate = DateFormatter.formatUSDate(d);
            }
          }
        }
      }

      this.filterDate = filterDate;
    },

    resetSearchStringBooked() {
      this.searchStringBooked = "";
      this.loadAllBookedBirthdays();
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    birthdayColumns: function (): TableViewColumnDefinitions<BirthdayBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Kind)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Programm",
          td: (i) => i.programTitle,
        },
        {
          th: "Ort",
          td: (i) => i.location,
        },
        {
          th: "Betreuer:in",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "Status",
          td: (i) => vue.BirthdayBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<BirthdayBookingJson>[];
    },

    todayBirthdaysPrint() {
      if (this.bookedBirthdayBookings != null) {
        if (this.birthdayInfo != null) {
          var printBirthdays: any = {};

          var birthdaysToPrint = JSON.parse(JSON.stringify(this.bookedBirthdayBookings));

          if (birthdaysToPrint != null) {
            var birthdaysDates: any = {};

            for (let k = 0; k < birthdaysToPrint.length; k++) {
              let date = DateFormatter.formatISODate(new Date(birthdaysToPrint[k].beginDateTime));

              if (!(date in birthdaysDates)) {
                birthdaysDates[date] = [];
              }

              let toPush = JSON.stringify(birthdaysToPrint[k]);

              birthdaysDates[date].push(toPush);
            }

            for (let l in birthdaysDates) {
              for (let i = 0; i < this.birthdayInfo.customTimeSlots.length; i++) {
                let time = this.birthdayInfo.customTimeSlots[i].beginTime;

                let birthdays = [];

                for (let j = 0; j < birthdaysDates[l].length; j++) {
                  //for (let j in printBirthdays[l]) {
                  let birthdayDetails = JSON.parse(birthdaysDates[l][j]);

                  if (birthdayDetails != undefined) {
                    if (DateFormatter.formatTime(new Date(birthdayDetails.beginDateTime)) == time) {
                      birthdays.push(birthdayDetails);
                      delete birthdaysDates[l][j];
                    }
                  }
                }

                birthdaysDates[l] = birthdaysDates[l].filter((item: any) => item != null);

                if (birthdays.length > 0) {
                  if (!(l in printBirthdays)) {
                    printBirthdays[l] = {};
                  }
                  printBirthdays[l][time] = {
                    time: "Ab " + time + " Uhr",
                    birthdays: birthdays,
                  };
                }
              }

              if (birthdaysDates[l].length > 0) {
                let birthdays = [];

                for (let m = 0; m < birthdaysDates[l].length; m++) {
                  birthdays.push(JSON.parse(birthdaysDates[l][m]));

                  if (!(l in printBirthdays)) {
                    printBirthdays[l] = {};
                  }
                  printBirthdays[l]["Weitere Uhrzeiten"] = {
                    time: "Weitere Uhrzeiten",
                    birthdays: birthdays,
                  };
                }
              }
            }
          }

          return printBirthdays;
        }
      }
    },
  },
});
